export class NativeStreamAggregationPinnedSpanLayout {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aligned",
            "baseName": "aligned",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "newest",
            "baseName": "newest",
            "type": "Array<number>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationPinnedSpanLayout.attributeTypeMap;
    }
    constructor() {
    }
}
